<main>
  <router-outlet *ngIf="!resolveReportLoader"></router-outlet>
  <via-loader
    class="loading_overlay"
    *ngIf="resolveReportLoader"
    [spinnerSize]="80"
  ></via-loader>
</main>
